import * as React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';
// import Flag from '../../images/flag.jpg';

const AcknowledgementStyled = styled.div`
	background-color: ${(props) => props.bgColor};
	//margin-bottom: 1rem;

	.acknowledgement {
		padding: 0.5em;
		margin-top: 3rem;
	}
	p {
		margin-top: 1rem;
		color: var(--primary);
	}

	.flag {
		display: flex;
		justify-content: left;
		align-items: center;
	}

	.acknowledgementText {
		text-align: left;
		margin-left: 1rem;
	}

	// mobile settings
	@media (max-width: 768px) {
		.flag {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.acknowledgementText {
			text-align: center;
			margin-left: 0;
		}
	}
`;

export default function Acknowledgement() {
	const data = useStaticQuery(graphql`
		query {
			allStrapiFooter {
				nodes {
					acknowledgement
				}
			}
			allStrapiAsset {
				nodes {
					footer_background_colour
				}
			}
		}
	`);
	const acknowledgementText = data.allStrapiFooter.nodes[0]?.acknowledgement;

	const backgroundColourRaw =
		data.allStrapiAsset.nodes?.[0]?.footer_background_colour;
	const backgroundColour = backgroundColourRaw
		? backgroundColourRaw.startsWith('--')
			? `var(${backgroundColourRaw})`
			: backgroundColourRaw.startsWith('var(')
			? backgroundColourRaw
			: backgroundColourRaw.startsWith('#') ||
			  backgroundColourRaw.startsWith('rgb')
			? backgroundColourRaw
			: `var(--${backgroundColourRaw})`
		: 'var(--neutral_1)'; // Fallback color

	// Debug logging
	// console.log('Acknowledgement background color debug:', {
	// 	raw: backgroundColourRaw,
	// 	processed: backgroundColour,
	// 	hasData: !!data.allStrapiAsset.nodes?.[0],
	// });

	return (
		<AcknowledgementStyled bgColor={backgroundColour}>
			<div className='acknowledgement'>
				<Container>
					<Row>
						{/* Column 1 */}
						{/* <Col xs={12} md={2} lg={1} className='flag'>
							<img alt='Australian Aboriginal Flag' src={Flag} />{' '}
						</Col> */}

						{/* Column 2 */}

						<Col xs={12} md={10} lg={12}>
							<p className='acknowledgementText'>{acknowledgementText}</p>
						</Col>
					</Row>
				</Container>
			</div>
		</AcknowledgementStyled>
	);
}
